import React from "react";
const config = require("../config");

class Quote extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            quote: {}
        };
    }
    componentDidMount() {
        fetch(config.quoteAPIEndpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Mashape-Key":
                    "6M0ovOnmKRmshPlR5VSm2UOzbNKMp1MsxRFjsnw1uzjs5y7UgC",
                Accept: "application/json"
            }
        })
            .then(res => res.json())
            .then(data =>
                // data => console.log(data)
                this.setState(state => ({
                    ...state,
                    ...{ quote: data[0] }
                }))
            );
    }

    componentWillUnmount() {
        this.setState(state => ({
            ...state,
            ...{ quote: null }
        }));
    }

    render() {
        return this.state.quote.hasOwnProperty("quote") &&
            this.state.quote.quote.length > 0 &&
            this.state.quote.author ? (
            <div className="quote-container">
                <center style={{ marginTop: "2%" }}>
                    <span className="quote">"{this.state.quote.quote}" - </span>
                    <span className="author">{this.state.quote.author}</span>
                </center>
            </div>
        ) : (
            ""
        );
    }
}

export default Quote;



// WEBPACK FOOTER //
// ./src/components/Quote.js